module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_70.c3d1641c.gif";